import PreviewAsset from '@/calendesk/models/PreviewAsset'
import { MutationTree } from 'vuex'
import { Preview } from './types'

export const mutations: MutationTree<Preview> = {
  SET_PREVIEW_ASSET (state, payload: PreviewAsset) {
    state.previewAsset = payload
  }
}
